<template>
  <div class="bg-[#23242A] text-white app-header p-4 custom">
    <div class="custom-full custom-left">
      <div class="">
        <div
          class="flex justify-between shadow-xl box-border items-center text-white h-[76px] rounded p-4 bg-[#2B2C32] mb-4"
        >
          <h2 class="font-bold text-2xl leading-[30px] tracking-[0.05px]">
            Purchase Order Report
          </h2>
          <div class="flex flex-row gap-6">
            <buttton @click="exportFile"
              class="h-[44px] py-2 px-4 cursor-pointer flex justify-center hover:opacity-60 items-center bg-white rounded-md font-medium text-sm leading-[17.5px] tracking-[1.2px] text-[#2BA66B]"
              >Export</buttton
            >
            <button
              @click="submit"
              class="h-[44px] py-2 px-4 cursor-pointer bg-white flex justify-center hover:opacity-60 items-center rounded-md font-medium text-sm leading-[17.5px] tracking-[1.2px] text-[#2BA66B]"
            >
              RUN REPORT
            </button>
          </div>
        </div>
        <div
          class="flex flex-col justify-start shadow-xl box-border text-white h-full rounded p-4 bg-[#2B2C32] mb-2"
        >

        <div class="flex items-end  xl:flex-row flex-col gap-3 mt-3 mb-3">
           <div class="xl:w-1/4 w-full">
             <div class="flex flex-col re-date" :class="'input-wrapper ' + (filter.startDate.error_type)">
               <label class="mb-0 text-xs">Start Date *</label>
               <div class="relative justify-center align-center input-clear">
                 <svg
                   width="16"
                   class="absolute z-[99] left-[10px] bottom-[12px]"
                   height="18"
                   viewBox="0 0 16 18"
                   fill="none"
                   xmlns="http://www.w3.org/2000/svg"
                 >
                   <path
                     d="M8 10.6667C7.76389 10.6667 7.56597 10.5869 7.40625 10.4272C7.24653 10.2674 7.16667 10.0695 7.16667 9.83342C7.16667 9.5973 7.24653 9.39939 7.40625 9.23967C7.56597 9.07994 7.76389 9.00008 8 9.00008C8.23611 9.00008 8.43403 9.07994 8.59375 9.23967C8.75347 9.39939 8.83333 9.5973 8.83333 9.83342C8.83333 10.0695 8.75347 10.2674 8.59375 10.4272C8.43403 10.5869 8.23611 10.6667 8 10.6667ZM4.66667 10.6667C4.43056 10.6667 4.23264 10.5869 4.07292 10.4272C3.91319 10.2674 3.83333 10.0695 3.83333 9.83342C3.83333 9.5973 3.91319 9.39939 4.07292 9.23967C4.23264 9.07994 4.43056 9.00008 4.66667 9.00008C4.90278 9.00008 5.10069 9.07994 5.26042 9.23967C5.42014 9.39939 5.5 9.5973 5.5 9.83342C5.5 10.0695 5.42014 10.2674 5.26042 10.4272C5.10069 10.5869 4.90278 10.6667 4.66667 10.6667ZM11.3333 10.6667C11.0972 10.6667 10.8993 10.5869 10.7396 10.4272C10.5799 10.2674 10.5 10.0695 10.5 9.83342C10.5 9.5973 10.5799 9.39939 10.7396 9.23967C10.8993 9.07994 11.0972 9.00008 11.3333 9.00008C11.5694 9.00008 11.7674 9.07994 11.9271 9.23967C12.0868 9.39939 12.1667 9.5973 12.1667 9.83342C12.1667 10.0695 12.0868 10.2674 11.9271 10.4272C11.7674 10.5869 11.5694 10.6667 11.3333 10.6667ZM8 14.0001C7.76389 14.0001 7.56597 13.9202 7.40625 13.7605C7.24653 13.6008 7.16667 13.4029 7.16667 13.1667C7.16667 12.9306 7.24653 12.7327 7.40625 12.573C7.56597 12.4133 7.76389 12.3334 8 12.3334C8.23611 12.3334 8.43403 12.4133 8.59375 12.573C8.75347 12.7327 8.83333 12.9306 8.83333 13.1667C8.83333 13.4029 8.75347 13.6008 8.59375 13.7605C8.43403 13.9202 8.23611 14.0001 8 14.0001ZM4.66667 14.0001C4.43056 14.0001 4.23264 13.9202 4.07292 13.7605C3.91319 13.6008 3.83333 13.4029 3.83333 13.1667C3.83333 12.9306 3.91319 12.7327 4.07292 12.573C4.23264 12.4133 4.43056 12.3334 4.66667 12.3334C4.90278 12.3334 5.10069 12.4133 5.26042 12.573C5.42014 12.7327 5.5 12.9306 5.5 13.1667C5.5 13.4029 5.42014 13.6008 5.26042 13.7605C5.10069 13.9202 4.90278 14.0001 4.66667 14.0001ZM11.3333 14.0001C11.0972 14.0001 10.8993 13.9202 10.7396 13.7605C10.5799 13.6008 10.5 13.4029 10.5 13.1667C10.5 12.9306 10.5799 12.7327 10.7396 12.573C10.8993 12.4133 11.0972 12.3334 11.3333 12.3334C11.5694 12.3334 11.7674 12.4133 11.9271 12.573C12.0868 12.7327 12.1667 12.9306 12.1667 13.1667C12.1667 13.4029 12.0868 13.6008 11.9271 13.7605C11.7674 13.9202 11.5694 14.0001 11.3333 14.0001ZM1.75 17.3334C1.41667 17.3334 1.125 17.2084 0.875 16.9584C0.625 16.7084 0.5 16.4167 0.5 16.0834V3.16675C0.5 2.83341 0.625 2.54175 0.875 2.29175C1.125 2.04175 1.41667 1.91675 1.75 1.91675H3.10417V0.666748H4.45833V1.91675H11.5417V0.666748H12.8958V1.91675H14.25C14.5833 1.91675 14.875 2.04175 15.125 2.29175C15.375 2.54175 15.5 2.83341 15.5 3.16675V16.0834C15.5 16.4167 15.375 16.7084 15.125 16.9584C14.875 17.2084 14.5833 17.3334 14.25 17.3334H1.75ZM1.75 16.0834H14.25V7.12508H1.75V16.0834ZM1.75 5.87508H14.25V3.16675H1.75V5.87508ZM1.75 5.87508V3.16675V5.87508Z"
                     fill="white"
                   />
                 </svg>
                 
                 <Datepicker
                   inputFormat="yyyy-MM-dd"
                   :clearable="true"
                   v-model="filter.startDate.value"
                   :class="filter.startDate.value?'text-[#fff]':'text-[#9E9E9E]'"
                   class="h-[40px] rounded-md bg-gray-black w-full border-none text-base leading-5 pl-[34px]"
                   placeholder="Select a Date"
                 />
               </div>
               <p class="field-error label-text mt-1" v-if="filter.startDate.error_message" v-text="filter.startDate.error_message"></p>
               <p class="label-text mt-1" v-else>&nbsp;</p>
             </div>
           </div>
           <div class="xl:w-1/4 w-full">
             <div class="flex flex-col re-date" :class="'input-wrapper ' + (filter.endDate.error_type)">
               <label class="mb-0 text-xs">End Date *</label>
               <div class="relative justify-center align-center input-clear">
                 <svg
                   width="16"
                   class="absolute z-[99] left-[10px] bottom-[12px]"
                   height="18"
                   viewBox="0 0 16 18"
                   fill="none"
                   xmlns="http://www.w3.org/2000/svg"
                 >
                   <path
                     d="M8 10.6667C7.76389 10.6667 7.56597 10.5869 7.40625 10.4272C7.24653 10.2674 7.16667 10.0695 7.16667 9.83342C7.16667 9.5973 7.24653 9.39939 7.40625 9.23967C7.56597 9.07994 7.76389 9.00008 8 9.00008C8.23611 9.00008 8.43403 9.07994 8.59375 9.23967C8.75347 9.39939 8.83333 9.5973 8.83333 9.83342C8.83333 10.0695 8.75347 10.2674 8.59375 10.4272C8.43403 10.5869 8.23611 10.6667 8 10.6667ZM4.66667 10.6667C4.43056 10.6667 4.23264 10.5869 4.07292 10.4272C3.91319 10.2674 3.83333 10.0695 3.83333 9.83342C3.83333 9.5973 3.91319 9.39939 4.07292 9.23967C4.23264 9.07994 4.43056 9.00008 4.66667 9.00008C4.90278 9.00008 5.10069 9.07994 5.26042 9.23967C5.42014 9.39939 5.5 9.5973 5.5 9.83342C5.5 10.0695 5.42014 10.2674 5.26042 10.4272C5.10069 10.5869 4.90278 10.6667 4.66667 10.6667ZM11.3333 10.6667C11.0972 10.6667 10.8993 10.5869 10.7396 10.4272C10.5799 10.2674 10.5 10.0695 10.5 9.83342C10.5 9.5973 10.5799 9.39939 10.7396 9.23967C10.8993 9.07994 11.0972 9.00008 11.3333 9.00008C11.5694 9.00008 11.7674 9.07994 11.9271 9.23967C12.0868 9.39939 12.1667 9.5973 12.1667 9.83342C12.1667 10.0695 12.0868 10.2674 11.9271 10.4272C11.7674 10.5869 11.5694 10.6667 11.3333 10.6667ZM8 14.0001C7.76389 14.0001 7.56597 13.9202 7.40625 13.7605C7.24653 13.6008 7.16667 13.4029 7.16667 13.1667C7.16667 12.9306 7.24653 12.7327 7.40625 12.573C7.56597 12.4133 7.76389 12.3334 8 12.3334C8.23611 12.3334 8.43403 12.4133 8.59375 12.573C8.75347 12.7327 8.83333 12.9306 8.83333 13.1667C8.83333 13.4029 8.75347 13.6008 8.59375 13.7605C8.43403 13.9202 8.23611 14.0001 8 14.0001ZM4.66667 14.0001C4.43056 14.0001 4.23264 13.9202 4.07292 13.7605C3.91319 13.6008 3.83333 13.4029 3.83333 13.1667C3.83333 12.9306 3.91319 12.7327 4.07292 12.573C4.23264 12.4133 4.43056 12.3334 4.66667 12.3334C4.90278 12.3334 5.10069 12.4133 5.26042 12.573C5.42014 12.7327 5.5 12.9306 5.5 13.1667C5.5 13.4029 5.42014 13.6008 5.26042 13.7605C5.10069 13.9202 4.90278 14.0001 4.66667 14.0001ZM11.3333 14.0001C11.0972 14.0001 10.8993 13.9202 10.7396 13.7605C10.5799 13.6008 10.5 13.4029 10.5 13.1667C10.5 12.9306 10.5799 12.7327 10.7396 12.573C10.8993 12.4133 11.0972 12.3334 11.3333 12.3334C11.5694 12.3334 11.7674 12.4133 11.9271 12.573C12.0868 12.7327 12.1667 12.9306 12.1667 13.1667C12.1667 13.4029 12.0868 13.6008 11.9271 13.7605C11.7674 13.9202 11.5694 14.0001 11.3333 14.0001ZM1.75 17.3334C1.41667 17.3334 1.125 17.2084 0.875 16.9584C0.625 16.7084 0.5 16.4167 0.5 16.0834V3.16675C0.5 2.83341 0.625 2.54175 0.875 2.29175C1.125 2.04175 1.41667 1.91675 1.75 1.91675H3.10417V0.666748H4.45833V1.91675H11.5417V0.666748H12.8958V1.91675H14.25C14.5833 1.91675 14.875 2.04175 15.125 2.29175C15.375 2.54175 15.5 2.83341 15.5 3.16675V16.0834C15.5 16.4167 15.375 16.7084 15.125 16.9584C14.875 17.2084 14.5833 17.3334 14.25 17.3334H1.75ZM1.75 16.0834H14.25V7.12508H1.75V16.0834ZM1.75 5.87508H14.25V3.16675H1.75V5.87508ZM1.75 5.87508V3.16675V5.87508Z"
                     fill="white"
                   />
                 </svg>
                 
                 <Datepicker
                   inputFormat="yyyy-MM-dd"
                   :clearable="true"
                   v-model="filter.endDate.value"
                   :class="filter.endDate.value?'text-[#fff]':'text-[#9E9E9E]'"
                   class="h-[40px] rounded-md bg-gray-black w-full border-none text-base leading-5 pl-[34px]"
                   placeholder="Select a Date"
                 />
               </div>
               <p class="field-error label-text mt-1" v-if="filter.endDate.error_message" v-text="filter.endDate.error_message"></p>
               <p class="label-text mt-1" v-else>&nbsp;</p>
             </div>
           </div>

           <div class="xl:w-1/4 w-full">
             <div :class="'input-wrapper relative ' + (filter.locationIds.error_type)">
               <label class="mb-0 text-xs">Locations</label>
               <SelectLocation
                 class="bg-gray-black rounded relative"
                 classValue="top-10"
                 v-model="filter.locationIds.value"
                 :options="vg_locations"
                 placeholder="Select One"
               />
               <p class="field-error label-text mt-1" v-if="filter.locationIds.error_message" v-text="filter.locationIds.error_message"></p>
               <p class="label-text mt-1" v-else>&nbsp;</p>
             </div>
           </div>

           <div class="xl:w-1/4 w-full">
               <div :class="'input-wrapper flex flex-col ' + filter.shipmentId.error_type">
                 <label class="mb-0 text-xs">PO Number (optional)</label>
                 <input
                   v-model="filter.shipmentId.value"
                   :class="' h-[40px] flex justify-start items-center placeholder-[#9E9E9E] rounded-md bg-gray-black w-full border-none text-base leading-5 p-2'"
                   placeholder="Enter order #"
                   type="text"
                 />
                 <p
                   class="field-error label-text mt-1"
                   v-if="filter.shipmentId.error_message"
                   v-text="filter.shipmentId.error_message"
                 ></p>
                 <p class="field-error label-text mt-1" v-else>&nbsp;</p>
               </div>
           </div>
         </div>

          <h5 class="font-normal text-xs leading-5 mb-3 tracking-[0.15px]">
            Export File Format
          </h5>
          <div class="flex items-center gap-[18px] pb-4">
            <div class="flex items-center">
              <input
                checked
                @click="selectFormat('csv')"
                id="format"
                value="csv"
                type="radio"
                name="no_reward"
                class="w-4 h-4 bg-transparent border-2 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
              />
              <label
                for="format"
                class="ml-2 text-base leading-5 font-normal tracking-wider text-white dark:text-gray-300"
                >XLSX</label
              >
            </div>
          </div>
        </div>
        <List
          v-if="payload && payload.length > 0"
          :payload="payload"
          :filter="filter"
        />
        <div class="text-theme-red" v-else-if="loaded">
          No Data Found.
        </div>
        <CategoryWithProductModal v-if="categoryProductPop" :existingproducts="filter.productIds.value"  :closeClick="closeCategoryWithProductModal" :actionClick="setCategoriesWithProduct"/>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'
import Datepicker from 'vue3-datepicker'
import SelectLocation from '@/components/form/SelectLocations'
import { mapGetters, mapMutations } from 'vuex'
import { useSnackbar } from "vue3-snackbar"
import CategoryWithProductModal from '@/components/CategoriesWithProductModal.vue';
import Helpers from '@/helpers';
import ReportHelpers from '@/helpers/report'
import ReportApis from '@/controllers/ReportApis'
import moment from 'moment'
import writeXlsxFile from 'write-excel-file';
import ProductApi from '@/controllers/BusinessProductApis'
import SelectCheckbox from '@/components/form/SelectCheckbox.vue'
import List from './List'

export default defineComponent({
  components: {
    List,
    Datepicker,
    SelectLocation,
    SelectCheckbox,
    CategoryWithProductModal
  },
  setup() {
    const snackbar = useSnackbar();
    const filter = ref({
      startDate: {
        value: null,
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
      endDate: {
        value: null,
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
      locationIds: {
        value: [],
        error_type: '',
        error_message: '',
        validations: [''],
      },
      shipmentId: {
        value: '',
        error_type: '',
        error_message: '',
        validations: [''],
      }
    })
    const categories = ref([])
    const categoryProductPop = ref(false)
    const downloadableCsv = ref([])
    const payload = ref([])
    const loaded = ref(false)

    return {
      snackbar,
      filter,
      categories,
      categoryProductPop,
      downloadableCsv,
      payload,
      loaded
    }
  },
  mounted(){
    this.getCategory()
  },
  computed: {
    ...mapGetters({
      vg_locations: 'location/list'
    })
  },
  methods: {
    selectType(val) {
      this.filter.includeLot.value = val
    },
    selectFormat(type) {
      this.filter.type.value = type
    },
    openCategoryProductModal(){
      this.categoryProductPop = true;
    },
    closeCategoryWithProductModal() {
      this.categoryProductPop = false;
    },
    /**
     * Get data selected from category modal
     */
    setCategoriesWithProduct(data) {
      this.filter.productIds.value = data.pids;
      this.closeCategoryWithProductModal();
    },
    async validateFields(fields) {
        let res = await Helpers.validateFormFields(this.filter, fields);
        // capture the fields
        this.form = res.data;
        return res.error ? false : true;
    },
    async submit() {
      this.loaded = false
      this.payload = []
      let data = {}
      if(this.filter.shipmentId.value){
        data = {
          shipmentId: this.filter.shipmentId.value
        }
      }else{
        let validate = await this.validateFields(['startDate', 'endDate']);
        if(!validate) {
            return ;
        }
        data = {
          locationIds: this.filter.locationIds.value,
          shipmentId: this.filter.shipmentId.value
        }
        data.startDate = moment(this.filter.startDate.value).format('YYYY-MM-DD');
        data.endDate = moment(this.filter.endDate.value).format('YYYY-MM-DD');
      }
      this.vm_spinner(true)
      let res = await ReportApis.purchaseOrderReport(data)
      this.loaded = true
      this.vm_spinner(false)
      if(res.status == 200 || res.status == 201){
        this.payload = res?.data?.payload
        return res
      }else{
        this.payload = []
        return null
      }
    },
    async exportFile(){
      let res = await this.submit()
      if(res){
        this.createXlSheet(this.payload)
      }else{
        this.snackbar.add({
              type: 'info',
              text: 'Data not found!',
              duration: 3000,
          })
      }
    },

    async getCategory(){
            let res = await ProductApi.fetchAllCategory()
            if(res.data?.payload?.category){
                for(let i=0; i<res.data.payload.category.length; i++){
                    this.categories.push(res.data.payload.category[i])
                    if(res.data.payload.category[i].subCategories && res.data.payload.category[i].subCategories.length>0){
                        for(let j=0; j<res.data.payload.category[i].subCategories.length; j++){
                            this.categories.push(res.data.payload.category[i].subCategories[j])
                        }
                    }
                }
            }
        },

    async concatBatches(payload){
      let total = []
      if(payload?.length && payload?.length>0){
        for(let i=0; i<payload.length; i++){
          if(payload[i].batchUploadDetails?.length>0){
            for(let j=0; j<payload[i].batchUploadDetails.length; j++){
              let obj = {...payload[i]}
              obj.batchUploadDetails = [payload[i].batchUploadDetails[j]]
              total.push(obj)
            }
          }else{
            let obj = {...payload[i]}
            obj.categoryName = (payload[i].category && payload[i].category.parent)? payload[i].category.parentCategory.name : payload[i].category?.name
            obj.subCategoryName = (payload[i].category && payload[i].category.parentCategory) ? payload[i].category?.name : ''
            obj.batchUploadDetails = [{
              batch_lot: '--',
              cost: null,
              current_nou: 0,
              inventory_snapshot_batches: [],
              packaged_on: null
            }]
            total.push(obj)
          }
        }
      }
      return total
    },

    async createXlSheet(jsonData) {
      try {
        let schema = [
          {
            column: 'PO #',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.shipmentId ? i.shipmentId :''
          },
          {
            column: 'Status',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.status==='inprogress'?'In Progress':(i.status ? i.status :'')
          },
          {
            column: 'Upload Date',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.date ? i.date :''
          },
          // {
          //   column: 'Supplier',
          //   type: String,
          //   wrap: false,
          //   alignVertical: 'center',
          //   align: 'center',
          //   value: i => ''
          // },
          {
            column: 'Location',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.location?.id ? i.location.name : '' 
          },
          {
            column: '# of Products Ordered',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.sumOfProductsQty ? i.sumOfProductsQty : null
          },
          {
            column: '# of Products Received',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.sumOfProductsQty ? i.sumOfProductsQty : null
          },
          {
            column: 'Expected Cost',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.expectedTotal ? i.expectedTotal : null
          },
          {
            column: 'Received Cost',
            type: Number,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.receivedTotal ? i.receivedTotal : null
          },
          {
            column: 'Fully Received',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.status==='completed' ? 'yes' : 'no'
          },
          {
            column: 'Created By',
            type: String,
            wrap: false,
            alignVertical: 'center',
            align: 'center',
            value: i => i.createdByName?i.createdByName:''
          },
        ]

        let widthArr = await ReportHelpers.calculateWidth(schema)
        await ReportHelpers.addWidthToSchema(schema, widthArr)
        let xlBlob = await writeXlsxFile(jsonData, {
          schema: schema,
        });
        let fileName = `Purchase-Order.xlsx`;
        let url = URL.createObjectURL(xlBlob);
        let link = document.createElement("a");
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        let self = this
        setTimeout(function(){
          self.snackbar.add({
            type: 'info',
            text: 'File downloaded',
            duration: 3000,
          })
        }, 1000)

      } catch(err) {
        console.log(err)
        return this.snackbar.add({
          type: 'info',
          text: 'Something went wrong. Please try again later.',
          duration: 3000,
        })
      }
    },
    isCurrentDate(date){
      if(!date) return
      return moment(moment().format('YYYY-MM-DD')).isSame(date)
    },

    ...mapMutations({
      vm_spinner: 'spinner/mutateSpinner'
    })
  }
})
</script>